import { useEffect } from 'react';
import { trackGoal } from '@/entities/trackGoal';

export const useTrackDigitalCheckout = () => {
    useEffect(() => {
        trackGoal('checkout_open', { referer: document?.referrer });
    }, []);
};
